import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function OccupationCategoryEditForm({ 
  category,
  btnRef,
  saveCategory
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={category}
      onSubmit={(values) => saveCategory(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="category">
            <Form.Label column sm={2}>
              Kategori<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.category} placeholder="Kategori" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}